import { SkeletonLine } from "..";

interface TitleSubTitleProps {
  readonly title: string;
  readonly subTitle: string;
  readonly isLoading: boolean;
}

export function TitleSubTitle({ title, subTitle, isLoading = false }: TitleSubTitleProps) {
  return (
    <div className="flex flex-col gap-1 min-w-[150px]">
    <span className="text-xl font-semibold text-content-on-dark-default">
      {isLoading ? <SkeletonLine /> : title}
    </span>
    <span>{isLoading ? <SkeletonLine className="max-h-5" /> : subTitle}</span>
  </div>
  );
}
